export default "__VITE_ASSET__DM6erf2h__"